<template>
  <div class="p-grid">
    <div class="p-sm-12 p-md-6 p-lg-4">
      <Card id="card-account">
        <template v-slot:title>
          Dados da Conta
          <span
            v-if="$route.params.id"
            style="font-size: 1.1rem; font-weight: 500"
          >
            #{{ $route.params.id }}
          </span>
        </template>
        <template v-slot:content>
          <AppForm
            ref="form"
            :rules="rules"
            :values="account"
            v-slot:default="{ formErrors }"
          >
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                <AppFormItem :error="formErrors.name" label="Nome">
                  <InputText v-model="account.name" />
                </AppFormItem>
              </div>

              <div class="p-field p-col-12 p-md-6">
                <AppFormItem label="Documento" :error="formErrors.document">
                  <InputText
                    v-model="account.document"
                    v-mask="['###.###.###-##', '##.###.###/####-##']"
                  />
                </AppFormItem>
              </div>

              <div class="p-field p-col-12 p-md-6">
                <AppFormItem label="Email" :error="formErrors.email">
                  <InputText v-model="account.email" />
                </AppFormItem>
              </div>

              <div class="p-field p-col-12 p-md-6">
                <AppFormItem label="Telefone">
                  <InputText
                    v-model="account.phone"
                    v-mask="['(##) ####-####', '(##) #####-####']"
                  />
                </AppFormItem>
              </div>

              <div class="p-field p-col-12 p-md-6">
                <AppFormItem label="Status" :error="formErrors.statusId">
                  <AppAutoComplete
                    valueField="id"
                    v-model="account.statusId"
                    :options="statusOptions"
                  ></AppAutoComplete>
                </AppFormItem>
              </div>

              <div class="p-field p-col-12 p-md-6">
                <AppFormItem label="Plano" :error="formErrors.planId">
                  <AppAutoComplete
                    valueField="id"
                    v-model="account.planId"
                    :options="planOptions"
                  ></AppAutoComplete>
                </AppFormItem>
              </div>

              <div class="p-field p-col-12 p-md-6">
                <AppFormItem
                  label="Ciclo de cobrança"
                  :error="formErrors.billingInterval"
                >
                  <AppAutoComplete
                    valueField="id"
                    v-model="account.billingInterval"
                    :options="billingIntervalOptions"
                  ></AppAutoComplete>
                </AppFormItem>
              </div>

              <div class="p-field p-col-12 p-md-6">
                <AppFormItem label="Valor mensal">
                  <InputNumber
                    v-model="account.billValue"
                    mode="currency"
                    currency="BRL"
                    locale="pt-BR"
                    :placeholder="
                      currentPlan?.billValue
                        ? `${$toCurrency(currentPlan?.billValue)} (plano)`
                        : ''
                    "
                  />
                </AppFormItem>
              </div>

              <div class="p-field p-col-12 p-md-6">
                <AppFormItem label="Dia de vencimento">
                  <InputNumber
                    v-model="account.dueDay"
                    mode="decimal"
                    :min="1"
                    :max="30"
                  />
                </AppFormItem>
              </div>

              <div class="p-field p-col-12 p-md-6">
                <AppFormItem label="Quantidade de Bovinos">
                  <InputNumber
                    v-model="account.bovineQuantity"
                    mode="decimal"
                    :placeholder="
                      currentPlan?.bovineQuantity
                        ? `${currentPlan?.bovineQuantity} (plano)`
                        : ''
                    "
                  />
                </AppFormItem>
              </div>

              <div class="p-field p-col-12 p-md-6">
                <AppFormItem label="Quantidade de Fazendas">
                  <InputNumber
                    v-model="account.farmQuantity"
                    mode="decimal"
                    :placeholder="
                      currentPlan
                        ? `${currentPlan?.farmQuantity || 'sem limite'} (plano)`
                        : ''
                    "
                  />
                </AppFormItem>
              </div>
              <div class="p-field p-col-12 p-md-6">
                <AppFormItem
                  label="Chave do veterinário"
                  v-if="account.planId === 4"
                >
                  <InputText :value="inviteCode" disabled />
                </AppFormItem>
              </div>
              <div class="p-field p-col-12">
                <AppFormItem label="Observações">
                  <Textarea v-model="account.observation" rows="3" />
                </AppFormItem>
              </div>
            </div>
          </AppForm>
        </template>

        <template v-slot:footer>
          <div class="p-grid p-jc-end">
            <!-- <div class="p-col status-container">
              <InputSwitch v-model="account.active"></InputSwitch>
              <p>Ativo</p>
            </div> -->
            <div style="padding-right: 8px">
              <router-link tag="span" :to="{ name: 'account.list' }">
                <Button label="Cancelar" class="p-button-outlined p-mr-2" />
              </router-link>
              <Button label="Salvar" @click="save()" :disabled="loadingSave" />
            </div>
          </div>
        </template>
      </Card>
    </div>
    <div class="p-sm-12 p-md-6 p-lg-8">
      <InvoiceCard
        :accountId="Number($route.params.id)"
        v-model:invoices="account.invoices"
      />
    </div>
    <div class="p-sm-12" v-if="$route.params.id">
      <div class="p-grid p-jc-end p-mt-2">
        <router-link tag="span" :to="{ name: 'account.list' }">
          <Button label="Voltar" class="p-button-outlined p-mr-2" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {
  AccountStatusApi,
  PlanApi,
  AccountApi,
} from '../../services/api/admin';
import { validateCPF, validateCNPJ, validateEmail } from '../../lib/helpers';
import InvoiceCard from './components/InvoiceCard.vue';

export default {
  name: 'AccountEdit',
  components: {
    InvoiceCard,
  },
  data() {
    return {
      rules: {
        statusId: [{ required: true, message: 'Selecione um status.' }],
        planId: [{ required: true, message: 'Selecione um plano.' }],
        name: [{ required: true, message: 'Informe o nome.' }],
        billingInterval: [
          { required: true, message: 'Selecione o ciclo de cobrança.' },
        ],
        document: {
          validator: (rule, value, callback) => {
            if (!value && this.$route.params.id) {
              return callback();
            }
            value = (value || '').replace(/\D/g, '');
            if (value.length === 11 && validateCPF(value)) {
              return callback();
            }
            if (value.length === 14 && validateCNPJ(value)) {
              return callback();
            }
            callback(new Error('Informe um documento válido.'));
          },
        },
        email: {
          validator(rule, value, callback) {
            if (!value) {
              callback(new Error('Informe um email.'));
            }
            if (validateEmail(value)) {
              return callback();
            }
            callback(new Error('Informe um email válido.'));
          },
        },
      },
      statusOptions: [],
      planOptions: [],
      billingIntervalOptions: [],
      loadingSave: false,
      account: {
        name: '',
        document: '',
        email: '',
        phone: '',
        statusId: null,
        planId: null,
        billValue: null,
        dueDay: null,
        bovineQuantity: null,
        observation: '',
        invoices: [],
        active: true,
        billingInterval: null,
      },
    };
  },
  async created() {
    await this.fetchData();
  },
  computed: {
    currentPlan() {
      return this.planOptions.find((plan) => plan.id === this.account.planId);
    },
    inviteCode() {
      const name = (this.account.name || '').toLowerCase().slice(0, 3);
      const document = (this.account.document || '')
        .replace(/\D/g, '')
        .slice(0, 6);
      return `${name}${document}`;
    },
  },
  methods: {
    async fetchData() {
      const statusReq = AccountStatusApi.fetch({
        order: 'asc',
        orderField: 'name',
      });
      const planReq = await PlanApi.fetch({ order: 'asc' });

      this.statusOptions = (await statusReq).results;
      this.planOptions = (await planReq).results;
      this.billingIntervalOptions = [
        { id: 'month', name: 'Mensal' },
        { id: 'year', name: 'Anual' },
      ];

      if (!this.$route.params.id) {
        return;
      }
      const account = await AccountApi.fetchById(this.$route.params.id);
      this.account = { ...account, invoices: [] };
    },
    async save() {
      try {
        if (!(await this.$refs.form.validate())) {
          return;
        }
        if (!this.validateInvoices()) {
          return;
        }

        this.loadingSave = true;

        const body = { ...this.account, inviteCode: this.inviteCode };
        if (!this.$route.params.id) {
          await AccountApi.create(body);
        } else {
          await AccountApi.update(this.$route.params.id, body);
        }
        this.$router.push({ name: 'account.list' });
      } catch (error) {
        this.handleError(error);
      }
      this.loadingSave = false;
    },
    validateInvoices() {
      if (this.$route.params.id) {
        return true;
      }
      const hasPendingInvoice = this.account.invoices.some(
        (invoice) => !invoice.paidDate
      );
      if (hasPendingInvoice) {
        return true;
      }
      this.$toast.add({
        severity: 'warn',
        summary: 'Atenção!',
        detail: 'Não é possível salvar a conta sem fatura em aberto.',
        life: 3000,
      });
      return false;
    },
    handleError(error) {
      console.log(error);
      let detail = 'Não foi possível salvar a conta.';
      if (error.response.data.code === 'AlreadyExistError') {
        detail = 'Já existe um cadastro com o email informado.';
      }
      this.$toast.add({
        severity: 'error',
        summary: 'Desculpe!',
        detail,
        life: 3000,
      });
    },
  },
};
</script>

<style scoped>
.status-container {
  position: relative;
}
.status-container p {
  margin: 0;
  position: absolute;
  top: 45%;
  transform: translate(0, -50%);
  margin-left: 50px;
}
</style>